import {
  cookieSecuritySettings,
  setCookie
} from '@daedalus/core/src/_web/utils/cookies'
import {safelyGetStorageItem} from '@daedalus/core/src/_web/utils/persistence'
import {MenuItemComponent} from '@daedalus/core/src/analytics/hooks/useTrackMenuItemClick'
import {CookieConsentContext} from '@daedalus/core/src/analytics/types/Events'
import {
  isReactNativeWebView,
  postMessageToWebView,
  RNWebViewMessageTypes
} from '@daedalus/core/src/native'

export enum CookieBannerClickComponent {
  AcceptButton = 'AcceptButton',
  RejectButton = 'RejectButton',
  PreferenceCenter = 'PreferenceCenter',
  CloseButton = 'CloseButton',
  AppPage = 'AppPage'
}

const getCookieConsentId = (): string => {
  const consentId =
    safelyGetStorageItem(localStorage, 'osano_consentmanager') ?? ''

  return consentId as string
}

const getEnabledCookieGroups = (): string[] => {
  if (typeof window === 'undefined') return []
  const consent = window.Osano?.cm?.getConsent() || ''

  return Object.entries(consent)
    .filter(([, value]) => value === 'ACCEPT')
    .map(([key]) => key)
}

export const getCookieConsentContext = (): CookieConsentContext => ({
  consentId: getCookieConsentId(),
  enabledCookieGroups: getEnabledCookieGroups()
})

export const storeCookieConsentTimestamp = () => {
  setCookie('cookieConsentTimestamp', Date.now().toString(), {
    expires: 365,
    ...cookieSecuritySettings(true)
  })
}

export const openCookiePreferencesCenter = () => {
  if (isReactNativeWebView()) {
    postMessageToWebView({
      type: RNWebViewMessageTypes.NAVIGATE,
      payload: {screen: MenuItemComponent.PrivacyPolicy}
    })
  } else {
    window.Osano?.cm?.showDrawer()
  }
}

export const getCookieConsentComponent = (consent: Record<string, string>) => {
  if (
    consent?.ANALYTICS === 'ACCEPT' ||
    consent?.PERSONALIZATION === 'ACCEPT' ||
    consent?.MARKETING === 'ACCEPT'
  ) {
    return CookieBannerClickComponent.AcceptButton
  }

  return CookieBannerClickComponent.RejectButton
}
